import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatRippleModule } from '@angular/material/core';
import { MatLegacyOptionModule as MatOptionModule } from '@angular/material/legacy-core';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { NotificationHandlerComponent, UtilitiesModule } from '@ebootis/utilities';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../shared/shared.module';
import { ArticleRoutingModule } from './article-routing.module';
import { ArticleCompareComponent } from './components/article-compare/article-compare.component';
import { ArticleDetailComponent, ArticleImageDialog } from './components/article-detail/article-detail.component';
import { ArticleSearchComponent } from './components/article-search/article-search.component';
import { ArticleDialog, ArticleSelectComponent } from './components/article-select/article-select.component';
import { ArticleTableComponent } from './components/article-table/article-table.component';
import { ArticleComponent } from './components/article/article.component';



@NgModule({
    declarations: [
        ArticleSearchComponent,
        ArticleTableComponent,
        ArticleSelectComponent,
        ArticleComponent,
        ArticleDetailComponent,
        ArticleDialog,
        ArticleCompareComponent,
        ArticleImageDialog
    ],
    imports: [
        CommonModule,
        ArticleRoutingModule,
        ReactiveFormsModule,
        TranslateModule.forChild(),
        MatFormFieldModule,
        MatInputModule,
        MatOptionModule,
        MatSelectModule,
        MatButtonModule,
        MatTableModule,
        MatPaginatorModule,
        MatTabsModule,
        MatTooltipModule,
        MatIconModule,
        MatCardModule,
        MatRippleModule,
        SharedModule,
        UtilitiesModule,
        MatDialogModule,
        MatSnackBarModule
    ],
    exports: [
        ArticleSelectComponent
    ]
})
export class ArticleModule { }
